import {
  Box,
  Button,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  Typography,
} from "@mui/material";
import { useNotifications } from "@toolpad/core";
import React, { useEffect, useState } from "react";
import {
  createRequest,
  fetchRequestsTypes,
} from "../services/pozadavkyService";

export default function SendRequestModal(props) {
  const [availableRequestTypes, setAvailableRequestTypes] = useState([]);
  const [selectedRequestType, setSelectedRequestType] = useState("");

  const [subject, setSubject] = useState("");
  const [text, setText] = useState("");
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const notifications = useNotifications();

  useEffect(() => {
    // kdykoli se modal otevře, vyresetuj texfieldy
    if (props.visible) {
      setSubject("");
      setText("");
      setSelectedRequestType("");
    }
  }, [props.visible]);

  useEffect(() => {
    setLoading(true);

    async function fetchTypes() {
      const result = await fetchRequestsTypes();
      if (result.success) {
        const data = result.data;
        setAvailableRequestTypes(data);
      } else {
        setError(result.message);
      }
      setLoading(false);
    }

    fetchTypes();
  }, []);

  const handleRequestSubmit = async (e) => {
    e.preventDefault();

    const result = await createRequest(selectedRequestType, subject, text);
    if (result.success) {
      props.setModalVisible(false);
      props.setRequests((prev) => [result.data, ...prev]);
      notifications.show("Požadavek byl úspěšně odeslan.", {
        severity: "success",
        autoHideDuration: 5000,
      });
    } else {
      setError(result.message || "Neznámá chyba.");
    }
  };

  if (loading) {
    return (
      <Box sx={{ textAlign: "center", p: 2 }}>
        <CircularProgress />
      </Box>
    );
  }

  if (error) {
    throw new Error(error);
  }
  return (
    <Box sx={{ p: 2, maxWidth: "500px" }}>
      <Typography variant="h5" sx={{ mb: 2 }}>
        Vytvořit nový požadavek
      </Typography>
      <form onSubmit={handleRequestSubmit}>
        <FormControl fullWidth sx={{ mb: 2 }}>
          <InputLabel id="demo-simple-select-label">Typ požadavku</InputLabel>
          <Select
            labelId="demo-simple-select-label"
            id="demo-simple-select"
            label="Typ požadavku"
            value={selectedRequestType}
            onChange={(event) => setSelectedRequestType(event.target.value)}
            sx={{ textAlign: "start" }}
            required
            fullWidth
          >
            {availableRequestTypes.map((type) => (
              <MenuItem value={type.id} key={type.id}>
                {type.nazev}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
        <TextField
          type="text"
          label="Předmět"
          variant="outlined"
          size="medium"
          fullWidth
          value={subject}
          onChange={(e) => setSubject(e.target.value)}
          required
          sx={{ mb: 2 }}
        />
        <TextField
          type="text"
          label="Text"
          variant="outlined"
          size="medium"
          fullWidth
          value={text}
          onChange={(e) => setText(e.target.value)}
          required
          sx={{ mb: 2 }}
        />

        <Button type="submit" variant="contained" color="primary">
          Odeslat požadavek
        </Button>
      </form>
    </Box>
  );
}
